export default __webpack_public_path__ + "static/media/collectionsList-empty.79976ed8.png";